import { PhoneCountryCodeSelectProps } from "./PhoneCountrySelect.types";
import { PhoneCountryCodeSelectRoot } from "./PhoneCountrySelect.styles";
import usePhoneCountryCodeSelect from "./hooks/usePhoneCountryCodeSelect";
import { TextField } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";

const PhoneCountryCodeSelect = (props: PhoneCountryCodeSelectProps) => {
    const { defaultValue, disabled, error, label: labelProp, placeholder = "+00", showValid, hideError, ...rest } = props;

    const translate = useTranslate();

    const { value, setValue, display, options } = usePhoneCountryCodeSelect(props);

    const label = labelProp ?? translate("selectCountryCode");

    return (
        <PhoneCountryCodeSelectRoot
            options={options}
            defaultValue={defaultValue}
            value={value}
            onChange={setValue}
            placeholder={translate("phoneNumberPlaceholder")}
            LabelProps={{
                children: (
                    <TextField
                        value={display}
                        disabled={disabled}
                        readonly
                        error={error}
                        placeholder={placeholder}
                        showValid={showValid}
                        hideError={hideError}
                    />
                ),
                gap: 4,
            }}
            disabled={disabled}
            error={error}
            label={label}
            {...rest}
        />
    );
};

export default PhoneCountryCodeSelect;
